// ViolationFields.js

//
// 1) The columns for your Violations table
//    (this is what you render in <tbody>, using `vio[field.key]`)
//
export const tableFields = [
  { key: "actions", label: "Actions" },

  // Basic IDs
  { key: "violationId",      label: "Violation ID" },
  //{ key: "inspectionNumber", label: "Inspection #" },
  //{ key: "inspectionId",     label: "Inspection ID" },

  // Date of violation
  //{ key: "violationDate",    label: "Violation Date" },

  // Possibly: "violationStatus" from your JSON
  { key: "violationStatus",  label: "Violation Status" },

  // Device & Agency
  { key: "deviceId",         label: "Device ID" },
  { key: "agencyId",         label: "Agency ID" },

  // Building
  { key: "buildingSite",     label: "Building Site" },

  // More date fields
  //{ key: "dateReceived",     label: "Date Received" },
  //{ key: "complianceDate",   label: "Compliance Date" },

  // "Item status" or any other high-level status
  //{ key: "itemStatus",       label: "Item Status" },

  // Potential user notes
  //{ key: "notes",            label: "Notes" },

  // Additional fields
  //{ key: "devicePart",           label: "Device Part" },
  //{ key: "violatingCondition",   label: "Violating Condition" },
  //{ key: "suggestedRemedy",      label: "Suggested Remedy" },
  //{ key: "additionalComment",    label: "Additional Comment" },
  //{ key: "estimatedAmount",      label: "Est. Amount" },
  //{ key: "resolutionMethod",     label: "Resolution Method" },
//
  //// If you have more, keep adding them:
  //{ key: "proposalNumber",       label: "Proposal Number" },
  //{ key: "approvalDate",         label: "Approval Date" },
  //{ key: "scheduleDate",         label: "Schedule Date" },
  //{ key: "scheduleTime",         label: "Schedule Time" },
  //{ key: "scheduleMechanic",     label: "Schedule Mechanic" },
  //{ key: "completedDate",        label: "Completed Date" },
  //{ key: "filedDate",            label: "Filed Date" },
  //{ key: "filedBy",              label: "Filed By" },
  //{ key: "includeInspectionCb",  label: "Include Inspection CB" },
  //{ key: "inspectionDate",       label: "Inspection Date" },
  //{ key: "closed",               label: "Closed" },
  //{ key: "closedDate",           label: "Closed Date" },
  //{ key: "violationStatusNum",   label: "Violation Status (Num)" },
  //{ key: "lastEditDate",         label: "Last Edit Date" },
  //{ key: "lastEditUser",         label: "Last Edit User" },
  //{ key: "numViolatingCond",     label: "# Violating Cond" },
  //{ key: "hearing",              label: "Hearing" },
  //{ key: "hearingDate",          label: "Hearing Date" },
];


//
// 2) The fields for the Violation Modal.
//
//    Typically you break them into "top" (gray) vs. "bottom" (yellow).
//    We'll call them `topSectionFields` and `bottomSectionFields`.
//    You can reorder them as needed.
//
//    The `name` should match the JSON keys in your data.
//

// 2a) The top (gray) section:
export const topSectionFields = [
  // Basic identification
  { name: "violationId",  label: "Violation Number",  type: "text",    readOnly: true },
  { name: "inspectionNumber", label: "Inspection #",      type: "text",    readOnly: true },
  { name: "inspectionId",     label: "Inspection ID",     type: "text",    readOnly: true },

  // Some building/device/agency info
  { name: "buildingSite",     label: "Building Site",     type: "text",    readOnly: true },
  { name: "deviceId",         label: "Device ID",         type: "text",    readOnly: true },
  { name: "agency",           label: "Agency",            type: "text",    readOnly: true },

  // If you store "issuedBy"
  { name: "issuedBy",         label: "Issued by",         type: "text" },

  // A description
  {
    name: "violationDescription",
    label: "Violation Description",
    type: "textarea",
  },
  { name: "agencyInspector",   label: "Agency Inspector",  type: "text" },

  // Checkboxes
  { name: "hazardous",         label: "Hazardous",         type: "checkbox" },
  { name: "ceaseUse",          label: "Cease Use",         type: "checkbox" },
  {
    name: "fileApplication",
    label: "File Application / Obtain Permit",
    type: "checkbox",
  },

  // Possibly a doc type dropdown
  {
    name: "violationDocType",
    label: "Document Type",
    type: "select",
    options: [
      { value: "ECB-PE (Rev. 5/15)",         label: "ECB-PE (Rev. 5/15)" },
      { value: "ECB-PE (Rev. 7/08)",         label: "ECB-PE (Rev. 7/08)" },
      { value: "ECB-PE / PVT (Rev. 01/03)",  label: "ECB-PE / PVT (Rev. 01/03)" },
      { value: "ECB-PE / PVT (Rev. 2001)",   label: "ECB-PE / PVT (Rev. 2001)" },
      { value: "ELV3 (Original)",            label: "ELV3 (Original)" },
      { value: "ELV3 (Rev 01/09 & 07/10)",   label: "ELV3 (Rev 01/09 & 07/10)" },
      { value: "ELV3 (Rev 01/12)",           label: "ELV3 (Rev 01/12)" },
      { value: "NYC - C1 and Periodic",      label: "NYC - C1 and Periodic" },
    ],
  },

  // Dates & numeric
  { name: "dateReceived",    label: "Date Received",     type: "date" },
  { name: "violationDate",   label: "Date of Violation", type: "date" },
  { name: "complianceDate",  label: "Compliance Date",   type: "date" },
  { name: "estimatedAmount", label: "Estimated Amount",  type: "number" },
];

// 2b) The bottom (yellow) section:
export const bottomSectionFields = [
  // The violationStatus as a <select>
  {
    name: "violationStatus",
    label: "Violation Status",
    type: "select",
    options: [
      { value: "1. ECB Received",                label: "1. ECB Received" },
      { value: "2. ECB surveyed",                label: "2. ECB surveyed" },
      { value: "3. ECB Proposed",                label: "3. ECB Proposed" },
      { value: "4. Job Created",                 label: "4. Job Created" },
      { value: "5. Work Completed",              label: "5. Work Completed" },
      { value: "6. Building Items not done",     label: "6. Building Items not done" },
      { value: "7. Reinspect building items",    label: "7. Reinspect building items" },
      { value: "8. COC sent to customer",        label: "8. COC sent to customer" },
      { value: "9. COC sent to expediter",       label: "9. COC sent to expediter" },
      { value: "10. COC sent to DOB",            label: "10. COC sent to DOB" },
      { value: "11. Corrected on DOB",           label: "11. Corrected on DOB" },
      { value: "12. MOD",                        label: "12. MOD" },
      { value: "13. Requested Stipulation",      label: "13. Requested Stipulation" },
      { value: "14. Disapproved",                label: "14. Disapproved" },
      { value: "15. Resubmitted Disapproval",    label: "15. Resubmitted Disapproval" },
      { value: "16. COC accepted by DOB Now",    label: "16. COC accepted by DOB Now" },
      { value: "17. DLM",                        label: "17. DLM" },
      { value: "18. CANCELLED SERVICE",          label: "18. CANCELLED SERVICE" },
      { value: "19. VIOLATION NOT FOUND ON DOB", label: "19. VIOLATION NOT FOUND ON DOB" },
      { value: "20. Fire Service",               label: "20. Fire Service" },
    ],
  },

  // You can add more if you want them in the bottom section:
  { name: "itemStatus",           label: "Item Status",         type: "text" },
  { name: "notes",                label: "Notes",               type: "textarea" },
  { name: "devicePart",           label: "Device Part",         type: "text" },
  { name: "violatingCondition",   label: "Violating Condition", type: "text" },
  { name: "suggestedRemedy",      label: "Suggested Remedy",    type: "text" },
  { name: "additionalComment",    label: "Additional Comment",  type: "textarea" },
  { name: "resolutionMethod",     label: "Resolution Method",   type: "text" },
  // etc. ...
];

//
// 3) Utility function to split an array of fields into two halves
//    so you can display half in one column, half in the other, etc.
//
export function splitFields(fieldsArray) {
  const midIndex = Math.ceil(fieldsArray.length / 2);
  return [fieldsArray.slice(0, midIndex), fieldsArray.slice(midIndex)];
}
